import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Translatable } from './translatable';

@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public readonly locale: string) {}

  transform(translatable?: Translatable, locale = this.locale): string {
    if (!translatable) {
      return '';
    }
    return translatable && translatable[locale]
      ? translatable[locale]
      : `Missing ${locale} translation`;
  }
}
